import { useDispatch, useSelector } from "react-redux";
import { ESRState } from "../types/data";
import { useEffect, useRef, useState } from "react";
import { Box, Fab } from "@mui/material";
import MessageIcon from '@mui/icons-material/Message';
import { FloatingMessageBox } from "./FloatingMessageBox";
import { listAllUnresolvedAndUnreadThreads, viewAllUnresolvedAndUnreadThreads } from "@/actions/util";
import { ESRThunkDispatch } from "@/actions/form";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export const FloatingMessage = () => {
    const threads = useSelector((s: ESRState) => s.filtered_threads);
    const unreadMessgCount = useSelector((s: ESRState) => s.unread_message_count);
    const fabLoadingThreads = useSelector((s: ESRState) => s.fab.fabLoadingThreads);
    const [user, setUser] = useCurrentUser();

    const dispatch = useDispatch<ESRThunkDispatch>();
    const [chatOpen, setChatOpen] = useState(false);
    const boxRef = useRef<HTMLDivElement>(null);
    function openThreads(): void {
        dispatch(viewAllUnresolvedAndUnreadThreads())
        setChatOpen(true);
    }
    function closeChatBox(): void {
        setChatOpen(false);
    }

    useEffect(() => {
            if (user) {
                dispatch(listAllUnresolvedAndUnreadThreads());
            }
    }, [user]);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                closeChatBox();
            }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
    }, []);
    return (
        <>   
           { (unreadMessgCount > 0) ? 
                <Box
                    ref={boxRef}
                    sx={{
                        position: 'fixed',
                        bottom: 100,
                        right: 50,
                        zIndex: 2,
                    }}
                >
                    {
                        chatOpen &&
                        <FloatingMessageBox threads={threads} loading={fabLoadingThreads} onChatClose={closeChatBox} />
                    }
                    <Fab
                        color="primary" aria-label="messages" sx={{ zIndex: 2 }}
                        onClick={openThreads}
                    >
                        <MessageIcon />
                    </Fab>
                    {
                        unreadMessgCount !== 0 &&
                        <Box
                            sx={{
                                position: 'absolute',
                                top: -5,
                                left: -4,
                                bgcolor: 'error.main',
                                color: 'white',
                                borderRadius: '50%',
                                width: 20,
                                height: 20,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                                zIndex: 3,
                                boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
                            }}
                        >
                            {unreadMessgCount}
                        </Box>
                    }
                    {/* {
                        numUnresolvedThreads !== 0 &&
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: -5,
                                left: -4,
                                bgcolor: '#FFA500',
                                color: 'white',
                                borderRadius: '50%',
                                width: 20,
                                height: 20,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                                zIndex: 3,
                                boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
                            }}
                        >
                            {numUnresolvedThreads}
                        </Box>
                    } */}
                </Box> 
            : null
           
           }
        </>
    )
}